/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function EmploymentInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Employment"
              description={
                <>
                <br />
                  <i><b><h3>Returning Officer</h3></b></i>
                  <br />
                  Elections Nova Scotia is currently recruiting qualified candidates for the challenging and rewarding role of returning officer in the following electoral districts: 
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Dartmouth North</li>
                    <li>Halifax Needham</li>
                    <li>Sackville-Uniacke</li>
                  </ul>
                  <br />
                  A returning officer administers the election within their electoral district. This is an excellent opportunity for professionals seeking part-time flexible work. Successful candidates must be impartial and declare they are non-partisan. Please see the following job description for more details: <a href="/files/Employment/Returning Officer Job Description.pdf">PDF</a> 
                  <br /><br />
                  If you are interested in finding out more about the role of a returning officer and current vacancies, please contact Elections Nova Scotia at 1-800-565-1504 or <a href="mailto:elections@novascotia.ca"><i><b><u>elections@novascotia.ca</u></b></i></a>.
                  <br /><br />
                  If you would like to apply now, please click the following link: <a href="https://enstools.electionsnovascotia.ca/jobapplication/">Application for Returning Officer</a>
                  <br />                 
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default EmploymentInformation;
